import React from 'react';
import { useTranslation } from 'react-i18next';
import useModuleData from '../../../../utils/hooks/useModuleData';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import TiersEmptyState from './TiersEmptyState';
import Tiers from './Tiers.connected';

const TiersBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isCurrentUserProfileOwner,
  profileOwnerUser,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const {
    moduleData: { tiers = [] },
  } = useModuleData(moduleId);
  const count = tiers.length;
  const isEmpty = count === 0;

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.tiers.header`, {
        count,
        username: profileOwnerUser.username,
      })}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        <TiersEmptyState
          isOwner={isCurrentUserProfileOwner}
          profileOwnerUser={profileOwnerUser}
        />
      }
    >
      <Tiers
        moduleId={moduleId}
        {...props}
        isOwner={isCurrentUserProfileOwner}
      />
    </WidgetBox>
  );
};

TiersBox.displayName = 'TiersBox';
export default TiersBox;
